/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */

import { useState, useEffect } from 'react'
import { jsx } from 'theme-ui'
import Tooltip from '../Tooltip/tooltip'

interface IPropsInputGroup {
  inputName: string
  returnInputValue: any
  labelText?: string
  placeholderText?: string
  maxValue?: string | number
  minValue?: string | number
  bindValue?: string
  inputValueSuffix?: string
  tooltipMessage?: string
  responseError?: string
  allowZero?: boolean
  suffix?: string
  prefix?: string
}

const InputGroup: React.FC<IPropsInputGroup> = ({
  labelText,
  inputName,
  placeholderText,
  returnInputValue,
  maxValue,
  minValue,
  bindValue,
  inputValueSuffix,
  tooltipMessage,
  responseError,
  allowZero = false,
  suffix,
  prefix,
}): JSX.Element => {
  const [value, setValue] = useState<string>(
    bindValue ? (inputValueSuffix ? `${bindValue}${inputValueSuffix}` : bindValue) : '0',
  )
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false)
  const [minValueError, setMinValueError] = useState<boolean>(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    const clearInputValue = inputValueSuffix
      ? e.target.value.replace(inputValueSuffix, '').replaceAll(' ', '')
      : e.target.value.replaceAll(' ', '')

    setValue(`${clearInputValue}${inputValueSuffix || ''}`)
  }

  const checkValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clearInputValue = inputValueSuffix
      ? e.target.value.replace(inputValueSuffix, '').replaceAll(' ', '')
      : e.target.value.replaceAll(' ', '')

    let temp: string | number =
      parseInt(clearInputValue) < 0 ? '0' : clearInputValue.trim() === '' ? '0' : clearInputValue

    setIsTooltipVisible(allowZero ? temp === '' || temp === '0' : false)

    if (maxValue && parseInt(temp) >= parseInt(String(maxValue))) temp = maxValue

    if (minValue !== undefined && parseInt(String(temp)) > parseInt(String(minValue))) {
      setMinValueError(false)
      setValue(`${temp}`)
    } else {
      setMinValueError(true)
    }
  }

  useEffect(() => {
    if (value === '') return
    returnInputValue(inputName, value)
  }, [value])

  useEffect(() => {
    if (!bindValue) return

    const obj: any = {
      target: {
        value: bindValue,
      },
    }
    handleChange(obj)
  }, [bindValue])

  return (
    <div sx={{ overflow: 'hidden' }}>
      <div
        sx={{
          maxWidth: '60%',
          float: 'left',
        }}
      >
        <label
          sx={{
            paddingTop: '5px',
            lineHeight: '1.5em',
            float: 'left',
          }}
          htmlFor={inputName}
        >
          {labelText}
        </label>

        <If condition={minValueError}>
          <div
            sx={{
              color: '#d64226',
              display: 'block',
              clear: 'left',
              fontSize: '0.8em',
              lineHeight: '1.5em',
            }}
          >
            Please ensure your {inputName} is more than £0.
          </div>
        </If>

        <If condition={Boolean(responseError)}>
          <div
            sx={{
              color: '#d64226',
              display: 'block',
              clear: 'left',
              fontSize: '0.8em',
              lineHeight: '1.5em',
            }}
          >
            {responseError}
          </div>
        </If>
      </div>

      <div
        sx={{
          display: 'table',
          borderCollapse: 'separate',
          position: 'relative',
          border: minValueError ? '2px solid #d64226' : 'solid 2px #e9ebed',
          borderRadius: '5px',
          overflow: 'hidden',
          float: 'right',
        }}
      >
        <If condition={Boolean(prefix)}>
          <span
            sx={{
              display: 'table-cell',
              verticalAlign: 'middle',
              fontSize: '1.3em',
              padding: ' 0 8px',
              backgroundColor: '#f4f5f6',
              width: '33px',
              boxSizing: 'border-box',
            }}
          >
            {prefix}
          </span>
        </If>

        <input
          sx={{
            float: 'right',
            clear: 'right',
            maxWidth: '60px',
            textAlign: 'left',
            borderRadius: '0',
            height: '37px',
            padding: '.35em .5em',
            fontSize: '1em',
            outline: '0',
            border: 'none',
            boxSizing: 'border-box',
          }}
          type='number'
          value={value}
          placeholder={placeholderText}
          name={inputName}
          onFocus={() => {
            setValue('')
            setIsTooltipVisible(false)
          }}
          onBlur={checkValue}
          onChange={handleChange}
        ></input>

        <If condition={Boolean(suffix)}>
          <span
            sx={{
              display: 'table-cell',
              verticalAlign: 'middle',
              fontSize: '1.3em',
              padding: ' 0 8px',
              backgroundColor: '#f4f5f6',
              width: '33px',
              boxSizing: 'border-box',
            }}
          >
            {suffix}
          </span>
        </If>

        <If condition={Boolean(tooltipMessage)}>
          <Tooltip text={tooltipMessage} show={isTooltipVisible} />
        </If>
      </div>
    </div>
  )
}
export default InputGroup
